import React, { useState, useEffect } from 'react';
import { useStore } from 'react-context-hook'
import { StyleSheet, ImageBackground, Image, View, ScrollView, ViewPagerAndroid, TextComponent } from "react-native";
import { Container, H1,  Header,  Title,  Button,  Card,  CardItem,  Icon,  Thumbnail,  Text,  Left,  Right,  Body, Footer, Grid, Col, Row } from "native-base";
import Styles from '../../Styles'
import Sentry from '../../utils/Sentry'
import { GiftedChat } from 'react-native-gifted-chat'

//Note: displays the individual chat thread for a partiuclar user
export default function MessagesThread({ navigation, threadData }) {

    const [platform] = useStore('platform')
    const [displayDesktop] = useStore('displayDesktop')
  
    // const [messages, setMessages] = useState([
    //     {
    //         _id: 0,
    //         text: 'Hello!',
    //         createdAt: new Date().getTime(),
    //         user: {
    //             _id: 2,
    //             name: 'test user'
    //         }
    //     }
    // ])

    const [messages, setMessages] = useState(threadData)    
  
    function handleSend(newMessage = []) {
        setMessages(GiftedChat.append(messages, newMessage))
    }
  
    return (
      // <ImageBackground source={global.BackgroundImage} style={displayDesktop ? Styles.Typography.generalAppContainer.desktop : Styles.Typography.generalAppContainer.mobile}>
        // <ScrollView style={{flex:1}} contentContainerStyle={{flexGrow:1}}>
        //   <View style={displayDesktop ? Styles.Typography.generalViewContainer.desktop : Styles.Typography.generalViewContainer.mobile}>
            
            <GiftedChat 
                messages={messages}
                onSend={newMessage => handleSend(newMessage)}
                user={{_id:1}}
            />

        //   </View>
        // </ScrollView>
      // </ImageBackground>
    );
  }